import styled from 'styled-components';

export const DataTime = styled.div`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.dimGray};
`;

export const TitleContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.xm}`}
    ${({ theme }) => theme.spacing.m} ${({ theme }) => `${theme.spacing.m}`}
    ${({ theme }) => theme.spacing.m};
`;

export const GridContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const NavContentTab = styled.div``;

export const CommentsContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.l}`}
    ${({ theme }) => theme.spacing.m};
`;

export const CommentsContent = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const ButtonMediaUploadWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.m};
  padding-left: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.seasalt};
`;

export const ImageInputContainer = styled.input`
  display: none;
`;
